import React, { Component } from 'react'
import './styles/dropdownButton.scss'
import { createPortal } from 'react-dom'
import Button from './Button'

class DropdownButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            portalDropdownStyle: {},
        }
        this.dropdownRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
        this.updatePosition()
    }

    componentDidUpdate(prevProps) {
        const { forceClose } = this.props
        if (forceClose && !prevProps.forceClose) {
            this.forceCloseDropdown()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
        this.stopTracking()
    }

    forceCloseDropdown = () => {
        this.stopTracking()

        this.setState({
            isOpen: false,
        })
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ isOpen: false })
        }
        this.stopTracking()
    }

    startTracking = () => {
        const { isOpen } = this.state
        const update = () => {
            if (isOpen) return

            this.updatePosition()
            this.raf = window.requestAnimationFrame(update)
        }

        this.raf = window.requestAnimationFrame(update)
    }

    stopTracking = () => {
        if (this.raf) window.cancelAnimationFrame(this.raf)
    }

    updatePosition = () => {
        if (!this.dropdownRef.current) return

        const rect = this.dropdownRef.current.getBoundingClientRect()

        this.setState({
            portalDropdownStyle: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: rect.width,
                transform: `translate(${rect.left}px, ${rect.bottom}px)`,
            },
        })
    }

    toggleDropdown = () => {
        this.setState(
            (prevState) => ({ isOpen: !prevState.isOpen }),
            () => {
                if (this.state.isOpen) {
                    this.updatePosition()
                    this.startTracking()
                } else {
                    this.stopTracking()
                }
            },
        )
    }

    handleClick = (onClick) => {
        this.setState({ isOpen: false })
        this.stopTracking()
        if (typeof onClick === 'function') onClick()
    }

    renderOption = (o, idx) => {
        switch (o.type) {
            case 'button':
                return (
                    <Button
                        key={`menu_${idx}`}
                        cssClass={`dropdown-button-item ${o.cssClass || ''}`}
                        onClick={() => this.handleClick(o.onClick)}
                        icon={o.icon}
                        style={o.style}
                    >
                        {o.label}
                    </Button>
                )
            default:
                return null
        }
    }

    renderMenu = () => {
        const { isOpen, portalDropdownStyle } = this.state
        const { options, usePortal } = this.props
        const menu = (
            <div
                className={`dropdown-button-menu ${usePortal ? 'portalled' : ''} ${isOpen ? 'open' : ''}`}
                style={usePortal ? portalDropdownStyle : undefined}
            >
                {options.map((o, idx) => (
                    this.renderOption(o, idx)
                ))}
            </div>
        )

        return usePortal
            ? createPortal(menu, document.body)
            : menu
    }

    render() {
        const { isOpen } = this.state
        const {
            label, hasChevronIcon, style,
        } = this.props

        return (
            <div className="dropdown-button-container" ref={this.dropdownRef} style={style}>
                <button
                    type="button"
                    className={`dropdown-button ${isOpen ? 'open' : ''}`}
                    onClick={this.toggleDropdown}
                >
                    <span className="dropdown-button-text">{label}</span>
                    {hasChevronIcon && (
                        <div className="chevron-container">
                            <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} dropdown-chevron`} />
                        </div>
                    )}
                </button>
                {this.renderMenu()}
            </div>
        )
    }
}

export default DropdownButton
